import Link from "next/link";
import MKLogo from "./svg/MKLogo";

function Logo() {
  return (
    <Link href="/" className='flex'>
      <div className="mx-2 flex items-center gap-2">
        <MKLogo w={21} h={25} />
        <div className="font-raleway md:text-3xl">Matěj Král</div>
      </div>
    </Link>
  );
}

export default Logo;
